import { Action } from '@ngrx/store';
import { ShoppingCart } from '../models/shopping-cart.model';
import { ApiResponse } from '../models/api-response.model';
import { CartDetailViewModel } from '../models/cart-item.model';

export enum ShoppingCartActionTypes {
    UpdateShoppingCart = '[ShoppingCart] Update',
    UpdateShoppingCartSuccess = '[ShoppingCart] UpdateSuccess',
    UpdateShoppingCartFailure = '[ShoppingCart] UpdateFailure',
    DeleteShoppingCart = '[ShoppingCart] Delete',
    DeleteShoppingCartSuccess = '[ShoppingCart] DeleteSuccess',
    DeleteShoppingCartFailure = '[ShoppingCart] DeleteFailure',
    LoadShoppingCart = '[ShoppingCart] Load',
    LoadShoppingCartSuccess = '[ShoppingCart] LoadSuccess',
    LoadShoppingCartFailure = '[ShoppingCart] LoadFailure',
    ShareShoppingCart = '[ShoppingCart] Share',
    ShareShoppingCartSuccess = '[ShoppingCart] ShareSuccess',
    ShareShoppingCartFailure = '[ShoppingCart] ShareFailure',
    CreateShoppingCart = '[ShoppingCart] Create',
    CreateShoppingCartSuccess = '[ShoppingCart] CreateSuccess',
    CreateShoppingCartFailure = '[ShoppingCart] CreateFailure',
    CloneShoppintCart = '[ShoppingCart]  Clone',
    CloneShoppintCartSuccess = '[ShoppingCart] CloneSuccess',
    CloneShoppintCartFailure = '[ShoppingCart] CloneFailure',
    SelectShoppingCartNoRedirect = '[ShoppingCart] SelectNoRedirect',
    SelectShoppingCartNoRedirectSuccess = '[ShoppingCart] SelectNoRedirectSuccess',
    SelectShoppingCartNoRedirectFailure = '[ShoppingCart] SelectNoRedirectFailure',
    SelectShoppingCart = '[ShoppingCart] Select',
    SelectShoppingCartSuccess = '[ShoppingCart] SelectSuccess',
    SelectShoppingCartFailure = '[ShoppingCart] SelectFailure',
    FilterShoppingCart = '[ShoppinhCart] Filter',
    LoadShoppingCartItem = '[ShoppingCartItem] Load',
    LoadShoppingCartItemSuccess = '[ShoppingCartItem] LoadSuccess',
    LoadShoppingCartItemFailure = '[ShoppingCartItem] LoadFailure',
    UpdateShoppingCartItemQty = '[ShoppingCartItem] UpdateQty',
    UpdateShoppingCartItemQtySuccess = '[ShoppingCartItem] UpdateQtySuccess',
    UpdateShoppingCartItemQtyFailure = '[ShoppingCartItem] UpdateQtyFailure',
    DeleteShoppingCartItem = '[ShoppingCartItem] Delete',
    DeleteShoppingCartItemSuccess = '[ShoppingCartItem] DeleteSuccess',
    DeleteShoppingCartItemFailure = '[ShoppingCartItem] DeleteFailure',
    InsertShoppingCartItem = '[ShoppingCartItem] Insert',
    InsertShoppingCartItemSuccess = '[ShoppingCartItem] InsertSuccess',
    InsertShoppingCartItemFailure = '[ShoppingCartItem] InsertFailure',
    CheckoutShoppingCart = '[ShoppingCart] Checkout',
    CheckoutShoppingCartSuccess = '[ShoppingCart] CheckoutSuccess',
    CheckoutShoppingCartFailure = '[ShoppingCart] CheckoutFailure',
}

export class LoadShoppingCart implements Action {
    readonly type = ShoppingCartActionTypes.LoadShoppingCart;
    constructor() { }
}

export class LoadShoppingCartSuccess implements Action {
    readonly type = ShoppingCartActionTypes.LoadShoppingCartSuccess;
    constructor(public payload: ShoppingCart[]) { }
}

export class LoadShoppingCartFailure implements Action {
    readonly type = ShoppingCartActionTypes.LoadShoppingCartFailure;
    constructor(public payload: string) { }
}

export class CreateShoppingCart implements Action {
    readonly type = ShoppingCartActionTypes.CreateShoppingCart;
    constructor(public payload: string = null) { }
}

export class CreateShoppingCartSuccess implements Action {
    readonly type = ShoppingCartActionTypes.CreateShoppingCartSuccess;
    constructor(public payload: ShoppingCart) { }
}

export class CreateShoppingCartFailure implements Action {
    readonly type = ShoppingCartActionTypes.CreateShoppingCartFailure;
    constructor(public payload: string) { }
}

export class DeleteShoppingCart implements Action {
    readonly type = ShoppingCartActionTypes.DeleteShoppingCart;
    constructor(public payload: number) {
    }

}
export class DeleteShoppingCartSuccess implements Action {
    readonly type = ShoppingCartActionTypes.DeleteShoppingCartSuccess;
    constructor(public payload: number) {
    }

}
export class DeleteShoppingCartFailure implements Action {
    readonly type = ShoppingCartActionTypes.DeleteShoppingCartFailure;
    constructor() {
    }
}

export class UpdateShoppingCart implements Action {
    readonly type = ShoppingCartActionTypes.UpdateShoppingCart;
    constructor(public payload: { cartId: number, cartName: string }) {
    }
}

export class UpdateShoppingCartSuccess implements Action {
    readonly type = ShoppingCartActionTypes.UpdateShoppingCartSuccess;
    constructor(public payload: { cartId: number, cartName: string }) {
    }
}

export class UpdateShoppingCartFailure implements Action {
    readonly type = ShoppingCartActionTypes.UpdateShoppingCartFailure;
    constructor() {
    }
}

export class CloneShoppingCart implements Action {
    readonly type = ShoppingCartActionTypes.CloneShoppintCart;
    constructor(public payload: number) { }
}

export class CloneShoppingCartSuccess implements Action {
    readonly type = ShoppingCartActionTypes.CloneShoppintCartSuccess;
    constructor(public payload: ShoppingCart) { }
}

export class CloneShoppingCartFailure implements Action {
    readonly type = ShoppingCartActionTypes.CloneShoppintCartFailure;
    constructor() { }
}

export class SelectShoppingCartNoRedirect implements Action {
    readonly type = ShoppingCartActionTypes.SelectShoppingCartNoRedirect;
    constructor(public payload: number) { }
}

export class SelectShoppingCartNoRedirectSuccess implements Action {
    readonly type = ShoppingCartActionTypes.SelectShoppingCartNoRedirectSuccess;
    constructor(public payload: number) { }
}

export class SelectShoppingCartNoRedirectFailure implements Action {
    readonly type = ShoppingCartActionTypes.SelectShoppingCartNoRedirectFailure;
    constructor() { }
}

export class SelectShoppingCart implements Action {
    readonly type = ShoppingCartActionTypes.SelectShoppingCart;
    constructor(public payload: ShoppingCart) {
    }
}


export class SelectShoppingCartSuccess implements Action {
    readonly type = ShoppingCartActionTypes.SelectShoppingCartSuccess;
    constructor(public payload: ShoppingCart) {
    }
}


export class SelectShoppingCartFailure implements Action {
    readonly type = ShoppingCartActionTypes.SelectShoppingCartFailure;
    constructor() {
    }
}

export class LoadShoppingCartItem implements Action {
    readonly type = ShoppingCartActionTypes.LoadShoppingCartItem;
    constructor(public payload: { cartId: number, shippingMethod: string }) {

    }
}
export class LoadShoppingCartItemSuccess implements Action {
    readonly type = ShoppingCartActionTypes.LoadShoppingCartItemSuccess;
    constructor(public payload: { cartId: number, items: CartDetailViewModel[] }) {

    }
}
export class LoadShoppingCartItemFailure implements Action {
    readonly type = ShoppingCartActionTypes.LoadShoppingCartItemFailure;
    constructor() {

    }
}

export class UpdateShoppingCartItemQty implements Action {
    readonly type = ShoppingCartActionTypes.UpdateShoppingCartItemQty;
    constructor(public payload: CartDetailViewModel) {
    }
}

export class UpdateShoppingCartItemQtySuccess implements Action {
    readonly type = ShoppingCartActionTypes.UpdateShoppingCartItemQtySuccess;
    constructor(public payload: CartDetailViewModel) {
    }
}

export class UpdateShoppingCartItemQtyFailure implements Action {
    readonly type = ShoppingCartActionTypes.UpdateShoppingCartItemQtyFailure;

}

export class DeleteShoppingCartItem implements Action {
    readonly type = ShoppingCartActionTypes.DeleteShoppingCartItem;
    constructor(public payload: CartDetailViewModel) {
    }
}

export class DeleteShoppingCartItemSuccess implements Action {
    readonly type = ShoppingCartActionTypes.DeleteShoppingCartItemSuccess;
    constructor(public payload: CartDetailViewModel) {
    }
}

export class DeleteShoppingCartItemFailure implements Action {
    readonly type = ShoppingCartActionTypes.DeleteShoppingCartItemFailure;
    constructor() {
    }
}

export class InsertShoppingCartItem implements Action {
    readonly type = ShoppingCartActionTypes.InsertShoppingCartItem;
    constructor(public payload: { stockCode: string, cartId: number, Qty: string }) {
    }
}

export class InsertShoppingCartItemSuccess implements Action {
    readonly type = ShoppingCartActionTypes.InsertShoppingCartItemSuccess;
    constructor(public payload: ShoppingCart) {
    }
}

export class InsertShoppingCartItemFailure implements Action {
    readonly type = ShoppingCartActionTypes.InsertShoppingCartItemFailure;
    constructor() {
    }
}

export class ShareShoppingCart implements Action {
    readonly type = ShoppingCartActionTypes.ShareShoppingCart;
    constructor(public payload: string) {

    }

}

export class ShareShoppingCartSuccess implements Action {
    readonly type = ShoppingCartActionTypes.ShareShoppingCartSuccess;
    constructor(public payload: { cartId: string, status: number }) {

    }
}

export class ShareShoppingCartFailure implements Action {
    readonly type = ShoppingCartActionTypes.ShareShoppingCartFailure;

}

export class CheckoutShoppingCart implements Action {
    readonly type = ShoppingCartActionTypes.CheckoutShoppingCart;
    constructor(public payload: { cartId: number, cartName: string }) { }
}

export class CheckoutShoppingCartSuccess implements Action {
    readonly type = ShoppingCartActionTypes.CheckoutShoppingCartSuccess;
    constructor(public payload: number) { }
}

export class CheckoutShoppingCartFailure implements Action {
    readonly type = ShoppingCartActionTypes.CheckoutShoppingCartFailure;

}
export type ShoppingCartActions = LoadShoppingCart | LoadShoppingCartSuccess | LoadShoppingCartFailure | CreateShoppingCart | CreateShoppingCartSuccess | CreateShoppingCartFailure | DeleteShoppingCart | DeleteShoppingCartSuccess | DeleteShoppingCartFailure | UpdateShoppingCart | UpdateShoppingCartSuccess | UpdateShoppingCartFailure | CloneShoppingCart | CloneShoppingCartSuccess | CloneShoppingCartFailure | SelectShoppingCartNoRedirect | SelectShoppingCartNoRedirectSuccess | SelectShoppingCartNoRedirectFailure | SelectShoppingCart | SelectShoppingCartSuccess | SelectShoppingCartFailure | LoadShoppingCartItem | LoadShoppingCartItemSuccess | LoadShoppingCartItemFailure | UpdateShoppingCartItemQty | UpdateShoppingCartItemQtySuccess | UpdateShoppingCartItemQtyFailure | DeleteShoppingCartItem | DeleteShoppingCartItemSuccess | DeleteShoppingCartItemFailure | InsertShoppingCartItem | InsertShoppingCartItemSuccess | InsertShoppingCartItemFailure | ShareShoppingCart | ShareShoppingCartSuccess | ShareShoppingCartFailure | CheckoutShoppingCart | CheckoutShoppingCartSuccess | CheckoutShoppingCartFailure;